import { getQuery, insertQuery, updateQuery } from "./PaymentgatewayWrapper.js";

const getCustomerDetails = async (customer_id) => {
  try {
    const data = JSON.stringify({
      query: `query CustomerDetails($customerId: String!) {
        customerDetails(customer_id: $customerId) {
          isSuccessful
          message
          resultObject
        }
      }`,
      variables: {
        customerId: customer_id
      }
    });
    const response = await getQuery(data);
    return response?.customerDetails;
  } catch (error) {
    console.log(error);
  }
};

const addCard = async (input) => {
  try {
    const data = JSON.stringify({
      query: `mutation AddCard($customerId: String!, $input: AddCardInput) {
      addCard(customer_id: $customerId, input: $input) {
        isSuccessful
        message
        resultObject
      }
    }`,
      variables: {
        customerId: input.customer,
        input: {
          card_number: input.cardNumber,
          cvc: input.cvc,
          exp_month: input.exp_month,
          exp_year: input.exp_year,
          name: input.name
        }
      }
    });
    const response = await insertQuery(data);
    return response?.addCard;
  } catch (error) {
    console.log(error);
  }
};

const updateCustomerDetails = async (customer_id, input) => {
  try {
    const data = JSON.stringify({
      query: `mutation Mutation($customerId: String!, $input: UpdateCustomerDetailsInput) {
        updateCustomerDetails(customer_id: $customerId, input: $input) {
          isSuccessful
          message
          resultObject
        }
      }`,
      variables: {
        customerId: customer_id,
        input: {
          address: input.address,
          address2: input.address2,
          city: input.city,
          contact_number: input.contactNumber,
          cust_country: input.custCountry,
          customer_name: input.customerName,
          email: input.email,
          postal_code: input.postalCode,
          shipping_city: input.shippingCity,
          shipping_country: input.shippingCountry,
          shipping_line1: input.shippingLine1,
          shipping_line2: input.shippingLine2,
          shipping_name: input.shippingName,
          shipping_phone: input.shippingPhone,
          shipping_postal: input.shippingPostal,
          shipping_state: input.shippingState,
          state: input.state
        }
      }
    });
    const response = await updateQuery(data);
    return response?.updateCustomerDetails;
  } catch (error) {
    console.log(error);
  }
};

const updateCustomerDefaultPaymentMethod = async (customer_id, payment_method_id) => {
  try {
    const data = JSON.stringify({
      query: `mutation UpdateCustomerDefaultPaymentMethod($customerId: String!, $paymentMethodId: String!) {
  updateCustomerDefaultPaymentMethod(customer_id: $customerId, payment_method_id: $paymentMethodId) {
    isSuccessful
    message
    resultObject
  }
}`,
      variables: { customerId: customer_id, paymentMethodId: payment_method_id }
    });
    const response = await updateQuery(data);
    return response?.updateCustomerDefaultPaymentMethod;
  } catch (error) {
    console.log(error);
  }
};

export { getCustomerDetails, addCard, updateCustomerDetails, updateCustomerDefaultPaymentMethod };
